import type { TodayData } from "@shared/webinar-api";

/**
 * Pastille de l'onglet « Aujourd'hui » : appels en retard + appels du jour
 * pas encore notés + relances du jour.
 */
export function todayBadgeCount(
  data: Pick<TodayData, "late" | "calls" | "followUps">,
): number {
  const open = (list: TodayData["calls"]) =>
    list.filter((c) => c.event.outcome == null).length;
  return open(data.late) + open(data.calls) + data.followUps.length;
}
